

document.addEventListener('DOMContentLoaded', function () {
  
 if (window.location.pathname == '/products/weasy-para-gato'){
console.log(window.localVariant.option1);
          var descargaVariantgato = window.localVariant.option1;
                 let descargagato = (a) => (a == 'Sem entrada de água') ? '<span><b>Sem Entrada de água</b> <span style="text-transform: initial;"><span></span><br><span style="text-transform: initial;"> Basta jogar um copo d\'agua para realizar a limpeza</span>' : (a == 'Com entrada de água') ? '<span><b>Com Entrada de água</b> <span style="text-transform: initial;"></span></span></br><span style="text-transform: initial;"> Conectado a uma torneira, Basta abri-la para realizar a limpeza<span>' : (a == 'Função Limpa Sozinho') ? '<span><b>Automática Smart+:</b> <span style="text-transform: initial;"></span></span></br><span style="text-transform: initial;"> Acionamento por sensor e monitoramento por app<span>': 'Descarga' 
                document.getElementById("description_descarga").innerHTML = descargagato(descargaVariantgato);

       var escoamentoVariantgato = window.localVariant.option2;
                 let escoamentogato = (a) => (a == 'Bag') ? '<span><b>Escoamento:</b> <span style="text-transform: initial;">WEASY BAG<span></span><br><span style="text-transform: initial;">  O xixi escorre da bandeja e é armazenado, ideal para quem não tem acesso a ralo</span>' : (a == 'Ralo') ? '<span><b>Escoamento:</b> <span style="text-transform: initial;">Ralo</span></span></br><span style="text-transform: initial;"> Por meio de uma mangueira ligada ao sistema de escoamento do banheiro weasy gato, o xixi vai direto para o ralo<span>' : 'Descarga' 
                document.getElementById("description_Escoamento").innerHTML = escoamentogato(escoamentoVariantgato);
 
 var firstTimeUrl = document.URL;
  document.addEventListener('change', function() {
  var currentPageUrl = document.URL;
  var url = new URL(currentPageUrl);
  var isVariantUrl = url.searchParams.get("variant");
  currentPageUrl = isVariantUrl ? currentPageUrl :isVariantUrl;
    if(currentPageUrl && firstTimeUrl != currentPageUrl) {
      firstTimeUrl = currentPageUrl;
      console.log('variant_id: '+isVariantUrl+'')
        var descargaVariantgato = window.localVariant.option1;
                 let descargagato = (a) => (a == 'Sem entrada de água') ? '<span><b>Sem Entrada de água</b> <span style="text-transform: initial;"><span></span><br><span style="text-transform: initial;"> Basta jogar um copo d\'agua para realizar a limpeza</span>' : (a == 'Com entrada de água') ? '<span><b>Com Entrada de água</b> <span style="text-transform: initial;"></span></span></br><span style="text-transform: initial;"> Conectado a uma torneira, Basta abri-la para realizar a limpeza<span>' : (a == 'Função Limpa Sozinho') ? '<span><b>Automática Smart+:</b> <span style="text-transform: initial;"></span></span></br><span style="text-transform: initial;"> Acionamento por sensor e monitoramento por app<span>': 'Descarga' 
                document.getElementById("description_descarga").innerHTML = descargagato(descargaVariantgato);

       var escoamentoVariantgato = window.localVariant.option2;
                 let escoamentogato = (a) => (a == 'Bag') ? '<span><b>Escoamento:</b> <span style="text-transform: initial;">WEASY BAG<span></span><br><span style="text-transform: initial;">  O xixi escorre da bandeja e é armazenado, ideal para quem não tem acesso a ralo</span>' : (a == 'Ralo') ? '<span><b>Escoamento:</b> <span style="text-transform: initial;">Ralo</span></span></br><span style="text-transform: initial;"> Por meio de uma mangueira ligada ao sistema de escoamento do banheiro weasy gato, o xixi vai direto para o ralo<span>' : 'Descarga' 
                document.getElementById("description_Escoamento").innerHTML = escoamentogato(escoamentoVariantgato);
      console.log('variant option 2: '+window.localVariant.option2+'')

    }
  });
  

const product_photos = document.getElementsByClassName("product__main-photos");
const product_stick = document.getElementsByClassName("product-single__sticky");
product_photos[0].style.marginBottom = "0px"; 

   

   product_stick[0].style.marginBottom = "0px"; 
   product_stick[0].style.backgroundColor = "#fff";
   product_stick[0].style.position = "sticky";

   product_stick[0].style.top = "30px";
   product_stick[0].style.zIndex = "10";

   

 }

// ------------------------ WEASY BOX ---------------------------------------------------------------------------------

// ------------------------ WEASY BOX ---------------------------------------------------------------------------------
  
  
if (window.location.pathname == '/pages/faq') {
    console.log('faq page');

    document.body.setAttribute('id', 'faq');

    var faqSection = document.querySelector('section#faq');
    if (faqSection) {
        var accordionHeaders = document.querySelectorAll('section#faq .accordion-header__faq');
        var h2Elements = document.querySelectorAll('h2');
        var h3Elements = document.querySelectorAll('h3');

        accordionHeaders.forEach(header => {
            header.addEventListener('click', function() {
                var accordionWrapper = this.closest('.accordion-wrapper__faq');
                var accordionContent = this.nextElementSibling;

                accordionContent.style.display = accordionContent.style.display === 'none' ? 'block' : 'none';
                accordionWrapper.classList.toggle('opened');
            });
        });

        var createSearchField = function() {
            var questionsWrapper = document.querySelectorAll('.accordion-wrapper__faq');
            var searchFieldWrapper = document.createElement('div');
            searchFieldWrapper.className = 'searchFieldWrapper';

            var searchField = document.createElement('input');
            searchField.className = 'searchField';
            searchField.type = 'text';
            searchField.placeholder = 'Procurar...';

            var clearFieldBtn = document.createElement('button');
            clearFieldBtn.className = 'clearField';

            var resultField = document.createElement('div');
            resultField.className = 'resultField';

            var clearFieldSearch = function() {
                searchField.value = '';
                questionsWrapper.forEach(wrapper => {
                    wrapper.style.display = 'block';
                });
                h2Elements.forEach(h2 => h2.style.display = 'block');
                h3Elements.forEach(h3 => h3.style.display = 'block');
                resultField.textContent = '';
            };

            searchField.addEventListener('keyup', function(e) {
                var fieldValue = e.target.value.toLowerCase();

                if (fieldValue) {
                    questionsWrapper.forEach(wrapper => {
                        wrapper.style.display = 'none';
                    });
                    h2Elements.forEach(h2 => h2.style.display = 'none');
                    h3Elements.forEach(h3 => h3.style.display = 'none');
                    questionsWrapper.forEach(item => {
                        if (item.innerText.toLowerCase().includes(fieldValue)) {
                            item.style.display = 'block';
                        }
                    });
                } else {
                    clearFieldSearch();
                }
            });

            clearFieldBtn.addEventListener('click', clearFieldSearch);

            searchFieldWrapper.appendChild(searchField);
            searchFieldWrapper.appendChild(clearFieldBtn);
            searchFieldWrapper.appendChild(resultField);

            faqSection.insertBefore(searchFieldWrapper, faqSection.firstChild);
        };

        createSearchField();
    }
}

  
      });


  






